// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_4c-0";
export var eligibilityCardNotEligible = "_4c-1";